module.exports = __webpack_public_path__ + "img/dischargeLocation.b19e5d35.svg";